import { TRANSITION_END, Scrollbar } from '../core'
import Favorites from './favorites'

// const MAP_STYLE = [{"featureType":"all","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"},{"saturation":"-100"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40},{"visibility":"off"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#e8dbc3"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ff0000"},{"lightness":20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#4d6059"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#7f8d89"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#7f8d89"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#0d5a65"},{"lightness":"-1"},{"weight":"0.005"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":"-26"},{"lightness":"-42"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":"30"},{"saturation":"-82"},{"gamma":"1.40"},{"weight":"1.56"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#314e54"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#2b3638"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#314e54"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]

const MAP_STYLE = [{"featureType":"all","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"},{"saturation":"-100"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40},{"visibility":"off"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#e8dbc3"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ff0000"},{"lightness":20}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"landscape","elementType":"geometry.stroke","stylers":[{"color":"#4d6059"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#1b3f47"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#7f8d89"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#7f8d89"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#292c2b"},{"lightness":"-1"},{"weight":"0.005"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#292c2b"},{"lightness":18},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":"-26"},{"lightness":"-42"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"lightness":"30"},{"saturation":"-82"},{"gamma":"1.40"},{"weight":"1.56"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#314e54"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#2b3638"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#314e54"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels.icon","stylers":[{"visibility":"off"}]}]

var mapSelf, mapModule

function arraysIntersect(arr1, arr2) {
  const set = new Set(arr1)
  return arr2.some(item => set.has(item))
}

$.fn.LocatorPanelCard = function(panel) {
  let self = this

  self.calculate_lines = function() {
    let description = self.find('.card-panel__description')
    description.css('display', 'block')
    let lineClamp = Math.floor(description.outerHeight(false) / 24 * (parseFloat($('body').css('font-size')) / 16))
    description.css({
      'display': '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': lineClamp + '',
    })
  }

  self.initialize_interface = function() {
    Favorites.buttons(self)
    $.mlmi.Fiches_Init(self)
    self.prepend('<button class="map-module__panel__close" title="' + bassaintlaurent_l10n.CLOSE_PANEL + '"></button>')
  }

  return function() {
    self.initialize_interface()
    $(window).on('resize orientationchange load', self.calculate_lines)
    requestAnimationFrame(function() {
      self.calculate_lines()
    })
    return self
  }()
}

$.fn.LocatorPanel = function(locator) {
  let self = this
  self.cardRequest = undefined
  self.currentCard = undefined
  self.currentFragmentPath = undefined

  self.loadCard = function(fragmentPath) {
    if (self.currentFragmentPath == fragmentPath) {
      return
    }
    if (self.currentCard != undefined) {
      self.closeCard()
    }
    if (self.cardRequest != undefined) {
      self.cardRequest.abort()
    }
    self.cardRequest = $.get('/fragment/' + bassaintlaurent_l10n.LANGUAGE + fragmentPath, function(x) {
      let card = $('<div></div>').append(x)
      self.addCard(card.find('.card-panel').LocatorPanelCard())
      self.cardRequest = undefined
    })
    self.currentFragmentPath = fragmentPath
  }

  self.addCard = function(newCard) {
    if (self.currentCard != undefined) {
      self.closeCard()
    }
    newCard.attr('aria-hidden', 'true')
    self.append(newCard)
    setTimeout(function() {
      self.currentCard = newCard
      self.currentCard.attr('aria-hidden', 'false')
    }, 50)
  }

  self.closeCard = function(e) {
    if (e != undefined) {
      e.preventDefault()
    }
    if (self.currentCard != undefined) {
      self.currentCard.attr('aria-hidden', 'true')
      self.currentCard.on(TRANSITION_END, function() {
        $(this).remove()
      })
      self.currentCard = undefined
    }
  }

  return function() {
    self.on('click', '.map-module__panel__close', function() {
      self.closeCard()
      self.currentFragmentPath = undefined
    })
    return self
  }()
}

$.fn.LocatorFiltersList = function() {
  let self = this

  self.button_clicked = function() {
    if ($(this).attr('aria-expanded') == 'false') {
      self.calculate_heights()
      $(this).attr('aria-expanded', 'true')
      $('#' + $(this).attr('aria-controls')).attr('aria-hidden', 'false')
    } else if ($(this).attr('aria-expanded') == 'true') {
      $(this).attr('aria-expanded', 'false')
      $('#' + $(this).attr('aria-controls')).attr('aria-hidden', 'true')
    }
  }

  self.calculate_heights = function() {
    self.find('.filters-list__group > ul').each(function() {
      if ($(this).attr('aria-hidden') == 'true') {
        $(this).css({
          'display': 'block',
          'max-height': 'none',
        })
      }
      $(this).css('--max-height', $(this).outerHeight(false) + 'px')
      if ($(this).attr('aria-hidden') == 'true') {
        $(this).css({
          'display': '',
          'max-height': '',
        })
      }
    })
  }

  return function() {
    self.find('.filters-list__parent').on('click', self.button_clicked)
    $(window).on('resize load orientationchange', self.calculate_heights)
    self.calculate_heights()
    return self
  }()
}

$.fn.LocatorFilters = function(locator) {
  let self = this

  if (self.data('locator-filters')) {
    return self.data('locator-filters')
  }

  self.reset_button = self.find('.map-module-filters__reset')
  self.destination_filters = self.find('input[type="checkbox"][name="map-destination"]')
  self.term_filters = self.find('input[type="checkbox"][name="map-filter"]')
  self.grouping_filters = self.find('input[type="checkbox"][name="grouping-filter"]')
  self.filters_list = self.find('.filters-list')

  self.reset_filters = function() {
    $('.map-module__panel__close').trigger('click')
    self.find('input[type="checkbox"]').prop('checked', false)
    self.find('input[type="checkbox"]').first().trigger('change')
  }

  self.filters_selected = function() {
    /* Filter groups */
    if ($(this).attr('name') == 'map-filter' || $(this).attr('name') == 'grouping-filter') {
      if ($(this).attr('value') == '#') {
        if ($(this).is(':checked')) {
          $(this).closest('ul').find('input[type="checkbox"]').prop('checked', true)
        } else {
          $(this).closest('ul').find('input[type="checkbox"]').prop('checked', false)
        }
      } else {
        if ($(this).is(':checked')) {
          var allChecked = true
          $(this).closest('ul').find('input[type="checkbox"]').each(function() {
            if ($(this).val() != '#' && !$(this).is(':checked')) {
              allChecked = false
            }
          })
          if (allChecked) {
            $(this).closest('ul').find('input[type="checkbox"][value="#"]').prop('checked', true)
          }
        } else {
          $(this).closest('ul').find('input[type="checkbox"][value="#"]').prop('checked', false)
        }
      }
    }

    /* Reset available */
    if (self.find('input[type="checkbox"]:checked').length) {
      self.reset_button.attr('aria-hidden', 'false')
      $('.map-module__filters-btn').addClass('map-module__filters-btn--reset')
    } else {
      self.reset_button.attr('aria-hidden', 'true')
      $('.map-module__filters-btn').removeClass('map-module__filters-btn--reset')
    }

    /* Trigger filtering */
    self.trigger('filters_changed')
  }

  self.initialize_interface = function() {
    self.destination_filters.on('change', self.filters_selected)
    self.term_filters.on('change', self.filters_selected)
    self.grouping_filters.on('change', self.filters_selected)
    self.reset_button.on('click', self.reset_filters)
    self.filters_list.LocatorFiltersList()
  }

  self.getCurrentDestinations = function() {
    let values = []
    self.destination_filters.filter(':checked').each(function() {
      values.push($(this).val())
    })
    return values
  }

  self.getCurrentFilters = function() {
    let values = []
    self.term_filters.filter(':checked').each(function() {
      if ($(this).val() != '#') {
        values.push($(this).val())
      }
    })
    return values
  }

  self.getCurrentGroupings = function() {
    let values = []
    self.grouping_filters.filter(':checked').each(function() {
      if ($(this).val() != '#') {
        values.push($(this).val())
      }
    })
    return values
  }

  return function() {
    self.initialize_interface()
    self.data('locator-filters', self)
    return self
  }()
}

/* Destination marker */
function DestinationMarker(map, marker) {
  this.map = map
  this.marker = marker
  this.filter = this.marker.data('filter')
  this.position = new google.maps.LatLng(parseFloat(this.marker.data('lat')), parseFloat(this.marker.data('lng')))
  this.div = null
  this.setMap(map)
}
DestinationMarker.prototype = new google.maps.OverlayView()
DestinationMarker.prototype.onAdd = function() {
  let marker = this.marker
  this.div = document.createElement('div')
  this.div.style.position = 'absolute'
  this.div.style.pointerEvents = 'none'
  this.div.innerHTML = this.marker.html()
  this.div.querySelector('a').onclick = function() {
    mapModule.panel.loadCard('/' + marker.data('uid') + '/panel/')
    return false
  }
  var panes = this.getPanes()
  panes.overlayMouseTarget.appendChild(this.div)
}
DestinationMarker.prototype.draw = function() {
  var overlayProjection = this.getProjection()
  var position = overlayProjection.fromLatLngToDivPixel(this.position)
  this.div.style.left = position.x + 'px'
  this.div.style.top = position.y + 'px'
}
DestinationMarker.prototype.onRemove = function() {
  if (this.div) {
    this.div.parentNode.removeChild(this.div)
    this.div = null
  }
}

$.fn.Locator = function(_isSingleLocation) {
  let self = this
  let IS_MEMORIAL = self.hasClass('--memorial-cup');

  if (self.data('mlmi-locator')) {
    return self.data('mlmi-locator')
  }

  self.isSingleLocation = _isSingleLocation
  self.locator = undefined
  self.locations = []
  self.destinations = []
  self.circuits = []
  self.filters = undefined
  self.panel = undefined
  self.first_load = true

  self.filters_changed = function() {
    if (!$('.map-module-filters').length) {
      return
    }

    /* Open checked parent on map load */
    if (self.first_load) {
      self.first_load = false
      setTimeout(function() {
        $('.filters-list__group input:checked').each(function() {
          if ($(this).closest('.filters-list__group').find('.filters-list__parent').attr('aria-expanded') == 'false') {
            self.filters.filters_list.calculate_heights()
            $(this).closest('.filters-list__group').find('.filters-list__parent').trigger('click')
          }
        })
      }, 500)
    }

    let destinationValues = self.filters.getCurrentDestinations(),
    filterValues = self.filters.getCurrentFilters(),
    groupingValues = self.filters.getCurrentGroupings(),
    allDestinations = (!destinationValues || !destinationValues.length),
    allFilters = (!filterValues || !filterValues.length),
    allGroupings = (!groupingValues || !groupingValues.length),
    filteredMarkers = []

    /* All markers */
    self.locator.markers.forEach(function(marker) {
      let hasDestination = false
      if (allDestinations) {
        hasDestination = true
      } else if (destinationValues.length) {
        if (marker.location.destination && destinationValues.indexOf(marker.location.destination) !== -1) {
          hasDestination = true
        }
      }

      let hasFilters = false
      if (allFilters) {
        hasFilters = true
      } else if (filterValues.length) {
        filterValues.forEach(function(filterValue) {
          if (marker.location.filters && marker.location.filters.indexOf(filterValue) !== -1) {
            hasFilters = true
          }
        })
      }

      let hasGrouping = false
      if (allGroupings) {
        hasGrouping = true
      } else if (groupingValues.length) {
        groupingValues.forEach(function(groupingValue) {
          if (marker.location.groupings && marker.location.groupings.indexOf(groupingValue) !== -1) {
            hasGrouping = true
          }
        })
      }

      if (hasDestination && hasFilters && hasGrouping) {
        if ((IS_MEMORIAL && marker.location.memorial)
        || (!IS_MEMORIAL && !marker.location.memorial_only)) {
          filteredMarkers.push(marker)
        }
      }
    })

    /* Update the markers including clusters and custom markers */
    self.groupingValues = groupingValues
    self.locator.clusterManager.clearMarkers()
    self.locator.clusterManager = new MarkerClusterer(self.locator.map, filteredMarkers, self.locator.options.clusterOptions)
    requestAnimationFrame(function() {
      /* Which destinations show up */
      self.destinations.forEach(function(destination) {
        destination.setMap(allDestinations || destinationValues.indexOf(destination.filter) !== -1 ? self.locator.map : null)
      })

      /* Which circuits show up */
      self.circuits.forEach(function(circuit) {
        let circuitMatchesDestination = (allDestinations || arraysIntersect(circuit.filter_data[3], destinationValues))
        circuit.setMap(groupingValues.indexOf(circuit.filter_data[1]) !== -1 && circuitMatchesDestination ? self.locator.map : null)
      })

      /* Autofit bounds on filter */
      if (filteredMarkers.length) {
        self.locator.autoFitBounds(filteredMarkers)
      }
    })
  }

  self.initialize_map = function() {
    /* Initialize locator */
    self.locator = self.MLMI_Locator(MAP_OPTIONS)

    /* Detect single location */
    if (self.closest('.fancybox-stage').length) {
      self.locator.isSingleLocation = true
    }

    /* No zoom control */
    if (!self.isSingleLocation) {
      self.locator.map.setOptions({
        zoomControl: false,
      })
    }

    /* Grab locations for filtering */
    if ('locations' in window) {
      self.locations = window.locations
    }

    /* Add KML Layers */
    if (!self.isSingleLocation && 'kmlCircuits' in window) {
      const filenames = ['circuit1_balade_secondaire_A.kml', 'circuit1_balade_secondaire_B.kml', 'circuit1_principal_raccourci.kml', 'circuit1_principal.kml', 'circuit2_balade_secondaire_A.kml', 'circuit2_balade_secondaire_B.kml', 'circuit2_principal.kml', 'circuit3_principal.kml', 'circuit4_balade_secondaire.kml', 'circuit4_principal.kml', 'circuit5_principal.kml', 'circuit6_principal.kml']
      filenames.forEach(function(filename) {
        let kmlLayer = new google.maps.KmlLayer('https://www.bassaintlaurent.ca/uploads/kml/' + filename, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: self.locator.map,
        })
        kmlLayer.filter_data = window.kmlCircuits[filename.substr(0, 8)]
        self.circuits.push(kmlLayer)

        /* Click on KML Layer */
        ;(function(layer, name) {
          google.maps.event.addListener(layer, 'click', function(kmlEvent) {
            mapModule.panel.loadCard('/' + window.kmlCircuits[name.substr(0, 8)][0] + '/panel/')
          })
        })(kmlLayer, filename)
      })
    }
  }

  self.initialize_interface = function() {
    if ($('.map-module__panel').length) {
      self.panel = $('.map-module__panel').LocatorPanel(self)
    }
    if ($('.map-module-filters').length) {
      self.filters = $('.map-module-filters').LocatorFilters(self)
    }
    $('.map-module__filters-btn').on('click', function() {
      $('.map__menu').attr('aria-hidden', 'false')
    })
    $('.map__menu__close-btn, .map__menu__filigrane').on('click', function() {
      $('.map__menu').attr('aria-hidden', '')
    })
    $('.map-module__zoom-out').on('click', function() {
      let targetZoom = self.locator.map.getZoom() - 1
      if (targetZoom >= MAP_OPTIONS.basicOptions.minZoom) {
        self.locator.map.setZoom(targetZoom)
      }
    })
    $('.map-module__zoom-in').on('click', function() {
      let targetZoom = self.locator.map.getZoom() + 1
      if (targetZoom <= MAP_OPTIONS.basicOptions.maxZoom) {
        self.locator.map.setZoom(targetZoom)
      }
    })
  }

  self.initialize_custom_markers = function(event, map) {
    if (self.isSingleLocation) {
      return
    }
    requestAnimationFrame(function() {
      $('.destination-marker').each(function() {
        if ($(this).data('lat') == '' || $(this).data('lng') == '') {
          return
        }
        let destination = new DestinationMarker(self.locator.map, $(this))
        self.destinations.push(destination)
      })
    })
  }

  self.initialize_events = function() {
    /* Marker clicked */
    self.locator.on('marker_clicked', function(event, map, marker) {
      self.panel.loadCard(marker.location.panel)
    })

    /* Zoom changed */
    self.locator.on('zoom_changed', function(event) {
      setTimeout(function() {
        self.destinations.forEach(function(destination) {
          destination.setMap(self.locator.map)
        })
      }, 400)

      if (!self.isSingleLocation) {
        let currentZoom = self.locator.map.getZoom()
        $('.map-module__zoom-out').prop('disabled', (currentZoom <= MAP_OPTIONS.basicOptions.minZoom))
        $('.map-module__zoom-in').prop('disabled', (currentZoom >= MAP_OPTIONS.basicOptions.maxZoom))
      }
    })

    /* Map clicked */
    self.locator.map.addListener('click', function(event) {
      $('.map-module__panel__close').trigger('click')
    })

    /* Markers rollover */
    let currentZ = 5000
    self.locator.markers.map(function(marker, i) {
      google.maps.event.addListener(marker, 'mouseover', function(event) {
        marker.setOptions({
          zIndex: currentZ++,
        })
      })
    })

    /* Filters changed */
    if (self.filters != undefined) {
      self.filters.on('filters_changed', self.filters_changed)
    }
    self.filters_changed()
  }

  var cluster = '/img/map/cluster-v2.svg';
  if (IS_MEMORIAL) {
    cluster = '/img/map/cluster-memorial.svg';
  }

  let MAP_OPTIONS = {
    selectors: {
      form: '.mlmi-locator-form',
      list: '.locations-list',
    },
    basicOptions: {
      zoom: $.mlmi.mobile.isMobile ? 8 : 9,
      singleMapZoom: $.mlmi.mobile.isMobile ? 8 : 9,
      maxZoom: 18,
      minZoom: $.mlmi.mobile.isMobile ? 8 : 9,
      lat: 48.005275,
      lng: -69.045185,
      mapStyle: MAP_STYLE,
      autoFitBounds: true,
      enableGeolocation: false,
      putSearchParametersInURL: false,
    },
    clusterOptions: {
      useClusters: true,
      styles: [{
        textColor: IS_MEMORIAL ? '#1B3F47' : '#F4F2E0',
        textSize: 13,
        fontFamily: 'Poppins',
        lineHeight: 36,
        url: cluster,
        height: 36,
        width: 36,
        backgroundSize: '36px 36px',
        iconAnchor: [18, 18],
        anchor: [0, 0]
      }],
      gridSize: 50,
      maxZoom: 13,
      zoomOnClick: 1,
      averageCenter: 1,
      minimumMarkersToEnableClusters: 5,
      minimumClusterSize: 5
    },
    bubbleOptions: {
      useBubbles: false,
    },
    getMarkerIcon: function(data) {
      let markerIcon = {
        url: '/img/map/marker-v2.svg',
        height: 30,
        width: 22.5,
        anchorY: 30,
        anchorX: 11.25,
        scaledHeight: 30,
        scaledWidth: 22.5,
      }
      if ('featured' in data && data.featured) {
        markerIcon.url = '/img/map/marker-featured.svg'
        markerIcon.zIndex = 3000
      }
      if (IS_MEMORIAL) {
        markerIcon.url = '/img/map/marker-memorial.svg'
        if ('featured' in data && data.featured) {
          markerIcon.url = '/img/map/marker-featured-memorial.svg'
          markerIcon.zIndex = 3000
        }
      }
      return markerIcon
    },
    filterMarkers: function(markers) {
      let acceptedMarkers = []
      if (markers.length < 5) {
        return markers
      }
      markers.forEach((marker, i) => {
        if (IS_MEMORIAL || (marker.lng > -71 && marker.lng < -67)) {
          acceptedMarkers.push(marker)
        }
      })
      return acceptedMarkers
    },
    filterBounds: function(bounds) {
      if (mapModule == undefined) {
        return bounds
      }
      if (mapModule.isSingleLocation) {
        return bounds
      }
      Object.values(window.kmlCircuits).forEach(function(circuit) {
        if (mapModule.groupingValues.indexOf(circuit[1]) !== -1) {
          let circuitBounds = circuit[2],
          ne = new google.maps.LatLng(circuitBounds.top, circuitBounds.right),
          sw = new google.maps.LatLng(circuitBounds.bottom, circuitBounds.left)
          bounds.extend(ne)
          bounds.extend(sw)
        }
      })
      return bounds
    },
  }

  return function() {
    $(window).on('markers_loaded', self.initialize_custom_markers)
    self.initialize_map()
    if (!self.isSingleLocation) {
      self.initialize_interface()
      self.initialize_events()
    }
    self.data('mlmi-locator', self)
    return self
  }()
}

var mapScope = document

export default {
  init(_scope, isSingleLocation) {
    mapSelf = this
    if (_scope != undefined) {
      mapScope = _scope
    }
    mapSelf.attachEvents(isSingleLocation)
  },

  attachEvents(isSingleLocation) {
    mapSelf = this
    if ($(mapScope).find('.map-module__map').length) {
      /* Initialize map when ready */
      if ("MLMI_Locator_Function" in window) {
        $.fn.MLMI_Locator = window.MLMI_Locator_Function
      }

      /* Not ready: call again shortly */
      if ($.fn.MLMI_Locator == undefined) {
        setTimeout(mapSelf.attachEvents, 150)
      } else {
        /* Ready: initialize */
        let locator = $(mapScope).find('.map-module__map').Locator(isSingleLocation)
        if (mapModule == undefined) {
          mapModule = locator // do not replace main with lightbox map
        }
      }
    }
  },
}
